"use client";

import { useState, useEffect } from "react";
import Link from "next/link";

const STORAGE_KEY = "cookie_consent";

export function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      const saved = localStorage.getItem(STORAGE_KEY);
      if (!saved) setVisible(true);
    } catch {
      // localStorage unavailable (SSR / private mode) — don't show
    }
  }, []);

  const accept = () => {
    try {
      localStorage.setItem(STORAGE_KEY, "accepted");
    } catch {}
    setVisible(false);
  };

  const decline = () => {
    try {
      localStorage.setItem(STORAGE_KEY, "declined");
    } catch {}
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      role="dialog"
      aria-live="polite"
      aria-label="Cookie consent"
      className="fixed bottom-0 left-0 right-0 z-[999] p-3 md:p-0"
    >
      <div className="md:mx-auto md:max-w-2xl md:mb-6 bg-white border border-border shadow-xl rounded-2xl px-4 py-3.5 flex flex-row items-center gap-3">
        {/* Icon */}
        <span className="text-xl leading-none shrink-0" aria-hidden="true">
          🍪
        </span>

        {/* Text */}
        <p className="text-xs sm:text-sm text-muted-foreground flex-1 min-w-0 leading-snug">
          We use essential cookies to keep this site working. By continuing, you
          agree to our{" "}
          <Link
            href="/privacy-policy"
            className="underline underline-offset-2 text-primary hover:text-primary/80 transition-colors"
          >
            Privacy Policy
          </Link>
          .
        </p>

        {/* Actions */}
        <div className="flex items-center gap-2 shrink-0">
          {/* <button
            onClick={decline}
            className="flex-1 sm:flex-none px-4 py-2 rounded-xl text-sm font-medium border border-border bg-transparent text-muted-foreground hover:bg-muted transition-colors"
          >
            Decline
          </button> */}
          <button
            onClick={accept}
            className="px-4 py-2 rounded-xl text-xs sm:text-sm font-medium bg-primary text-primary-foreground hover:bg-primary/90 transition-colors whitespace-nowrap"
          >
            Accept
          </button>
        </div>
      </div>
    </div>
  );
}
